export function getIdFromGid(gid = '') {
  if (gid.indexOf('gid') === -1) {
    return '';
  }
  return gid.split('/').pop();
}

export function getGidFromIdForResource(id, resource) {
  if (!id || !resource) {
    return;
  }
  return `gid://shopify/${resource}/${id}`;
}

export const RESOURCES = {
  SELLING_PLAN_GROUP: 'SellingPlanGroup',
  SUBSCRIPTION_CONTRACT: 'SubscriptionContract',
};
